import { mapState } from 'vuex';
import authors from '@/components/wai/authors/index.vue'

export default {
    name: 'biblist',
    props: {
        source : Object
    },
    components: {
        authors
    },
    data : function(){

        return {
            loading : false
        }

    },

}